/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.com/docs/browser-apis/
 */

import { withPrefix } from "gatsby";

const loadScript = (src) => {
  return new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = src;
    script.onload = resolve;
    script.onerror = reject;
    document.head.appendChild(script);
  });
};

export const onClientEntry = async () => {
  // Only load in development (scripts are loaded via SSR in production)
  if (process.env.NODE_ENV === 'development') {
    try {
      await loadScript(withPrefix('/javascript/jquery.js'));
      await loadScript(withPrefix('/javascript/underscore.js'));
      await loadScript(withPrefix('/javascript/backbone.js'));
      await loadScript(withPrefix('/vendor/bootstrap-sass-3.3.5/assets/javascripts/bootstrap.min.js'));
      await loadScript(withPrefix('/javascript/app.js'));
    } catch (error) {
      console.error('Failed to load scripts:', error);
    }
  }
};

// Re-initialize app after each page render
export const onRouteUpdate = () => {
  if (typeof window !== 'undefined' && window.app && window.app.init) {
    // Small delay to ensure DOM is ready
    setTimeout(() => {
      window.app.init();
    }, 100);
  }
};
